module.exports = __webpack_public_path__ + "img/CMR-XXX_1b.5379315a.png";